module.exports = __webpack_public_path__ + "static/media/appointment_accepted_in_the_past.f266ba2b.svg";